import { useEffect, useState } from 'react';

const getNodeBounds = (nodeIdOrClass, index = null) => {
  if (index !== null) return document.querySelectorAll(nodeIdOrClass)?.[index]?.getBoundingClientRect?.() || {};
  return document.querySelector(nodeIdOrClass)?.getBoundingClientRect?.() || {};
};

const useCarouselPosition = (isGlowRingsPDP = false, isBundlePDP = false) => {
  const [shouldBeFixed, setShouldBeFixed] = useState(false);
  const [shouldBeAbsolute, setShouldBeAbsolute] = useState(false);
  const navHeight = getNodeBounds('.Navigation').height || 0;

  useEffect(() => {
    window.addEventListener('scroll', updatePositionValues);

    return () => {
      window.removeEventListener('scroll', updatePositionValues);
    };

    // eslint-disable-next-line
  }, []);

  const updatePositionValues = () => {
    const carouselTopFixed = getNodeBounds('.ProductInformation').top || 0;
    const carouselTopDynamic = getNodeBounds('.ProductHeroSliderStyled').top || 0;
    const thumbsBottom = getNodeBounds('.HeroSliderSecondary').bottom || 0;
    const savingTop =
      getNodeBounds(isBundlePDP ? '.CustomerReviewSliderStyled' : isGlowRingsPDP ? '.SavingSectionStyled' : '.PressReviewSlider').top || 0;

    if (savingTop - thumbsBottom <= 140) {
      const isNavAbove = carouselTopDynamic > navHeight + 1;
      setShouldBeFixed(isNavAbove);
      setShouldBeAbsolute(!isNavAbove);
    } else if (carouselTopFixed <= navHeight) {
      setShouldBeFixed(true);
      setShouldBeAbsolute(false);
    } else if (carouselTopFixed > navHeight) {
      setShouldBeFixed(false);
      setShouldBeAbsolute(false);
    }
  };

  return { shouldBeFixed, shouldBeAbsolute, navHeight };
};

export default useCarouselPosition;
